"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortButton = exports.sortable = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var text_1 = require("../../text");
var icon_1 = require("../../icon");
var config_context_1 = require("../../_util/config-context");
var get_value_by_path_key_1 = require("../util/get-value-by-path-key");
function sortable(options) {
    // 当前列的排序优先级
    var sortablePrefer = new Map((options.columns || []).map(function (column) {
        return typeof column === "string"
            ? [column, "asc"]
            : [column.key, column.prefer];
    }));
    // 当前列的自定义排序函数
    var sortableCompare = new Map((options.columns || []).map(function (column) {
        return typeof column === "string"
            ? [column, undefined]
            : [column.key, column.sorter];
    }));
    // 当前列的排序状态
    var sortMap = new Map((options.value || []).map(function (sort) { return [sort.by, sort.order]; }));
    return {
        getInfo: function () { return ({ name: "sortable" }); },
        onInjectColumn: function (renderColumn) { return function (record, rowKey, recordIndex, column, columnIndex) {
            var columnResult = renderColumn(record, rowKey, recordIndex, column, columnIndex);
            // recordIndex > -1 是记录行，我们只注入表头
            if (recordIndex > -1) {
                return columnResult;
            }
            // 不是可排序列，跳过
            if (!sortablePrefer.has(column.key)) {
                return columnResult;
            }
            // 获取原始渲染内容
            var children = columnResult.children;
            // 当前的排序状态 undefined | "asc" | "desc"
            var order = sortMap.get(column.key);
            // 当前列的自定义排序函数
            var sorter = sortableCompare.get(column.key);
            // 切换排序状态
            var changeOrder = function (event) {
                if (typeof options.onChange !== "function") {
                    return;
                }
                var nextOrder;
                var prefer = sortablePrefer.get(column.key);
                if (!order) {
                    nextOrder = prefer;
                }
                if (order === "asc") {
                    nextOrder = prefer === "asc" ? "desc" : undefined;
                }
                if (order === "desc") {
                    nextOrder = prefer === "asc" ? undefined : "asc";
                }
                var sort = {
                    by: column.key,
                    order: nextOrder,
                    sorter: sorter,
                };
                // 删除旧排序规则，保证新的在前
                sortMap.delete(column.key);
                var value = (nextOrder ? [sort] : []).concat(Array.from(sortMap).map(function (_a) {
                    var _b = tslib_1.__read(_a, 2), by = _b[0], order = _b[1];
                    return ({ by: by, order: order });
                }));
                options.onChange(value, { event: event, sort: sort });
            };
            // 包装一个排序按钮
            children = (react_1.default.createElement(SortButton, { order: order, onClick: changeOrder }, children));
            return tslib_1.__assign(tslib_1.__assign({}, columnResult), { children: children });
        }; },
    };
}
exports.sortable = sortable;
function SortButton(_a) {
    var order = _a.order, className = _a.className, style = _a.style, children = _a.children, onClick = _a.onClick;
    var classPrefix = config_context_1.useConfig().classPrefix;
    var iconType = "sort";
    if (order === "asc") {
        iconType = "sortup";
    }
    if (order === "desc") {
        iconType = "sortdown";
    }
    return (react_1.default.createElement("span", { className: classnames_1.default(classPrefix + "-table__sortbtn", { "is-active": Boolean(order) }, className), style: style, onClick: onClick },
        react_1.default.createElement(text_1.Text, { overflow: true, className: classPrefix + "-table__headerop" }, children),
        react_1.default.createElement(icon_1.Icon, { type: iconType })));
}
exports.SortButton = SortButton;
function comparer(sorts) {
    return function (a, b) {
        var e_1, _a;
        try {
            for (var sorts_1 = tslib_1.__values(sorts), sorts_1_1 = sorts_1.next(); !sorts_1_1.done; sorts_1_1 = sorts_1.next()) {
                var _b = sorts_1_1.value, by = _b.by, order = _b.order, sorter = _b.sorter;
                var hasSorter = typeof sorter === "function";
                var firstValue = get_value_by_path_key_1.getValueByPathKey(a, by);
                var secondValue = get_value_by_path_key_1.getValueByPathKey(b, by);
                var isAsc = hasSorter ? sorter(a, b) < 0 : firstValue < secondValue;
                var isDesc = hasSorter ? sorter(a, b) > 0 : firstValue > secondValue;
                if (isAsc || isDesc) {
                    if (order === "asc")
                        return isAsc ? -1 : 1;
                    if (order === "desc")
                        return isDesc ? -1 : 1;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (sorts_1_1 && !sorts_1_1.done && (_a = sorts_1.return)) _a.call(sorts_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return 0;
    };
}
sortable.comparer = comparer;
//# sourceMappingURL=sortable.js.map